var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-12"},[_c('div',{staticClass:"container"},[(_vm.$slots.title)?_c('div',{staticClass:"flex items-center"},[_vm._t("title")],2):_vm._e(),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }